import { emptySchema } from '@contember/schema-utils';
import { emptySchemaExtensions, } from '../common';
import { StructureBuilder } from './builder/StructureBuilder';
import { StructureValidator } from './builder/StructureValidator';
import { emptyStructure } from './emptyStructure';
export class AppStructureDslBuilderError extends Error {
}
export class StructureDslBuilder {
    constructor(appStructure = emptyStructure, schema = emptySchema, schemaExtensions = emptySchemaExtensions, statementHandlers = {}, silentErrors = true) {
        Object.defineProperty(this, "statementHandlers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: statementHandlers
        });
        Object.defineProperty(this, "silentErrors", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: silentErrors
        });
        Object.defineProperty(this, "builder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.builder = new StructureBuilder(appStructure, schema, schemaExtensions);
    }
    getAppStructure() {
        return this.builder.application;
    }
    addView(viewName) {
        return this.builder.addView(viewName);
    }
    removeView(viewName) {
        return this.builder.removeView(viewName);
    }
    renameView(viewName, newViewName) {
        return this.builder.renameView(viewName, newViewName);
    }
    addComment(args) {
        return this.builder.addComment(args);
    }
    removeComment(args) {
        return this.builder.removeComment(args);
    }
    updateComment(args) {
        return this.builder.updateComment(args);
    }
    allowScope(args) {
        return this.builder.allowScope(args);
    }
    denyScope(args) {
        return this.builder.denyScope(args);
    }
    addScope(args) {
        return this.builder.addScope(args);
    }
    removeScope(args) {
        return this.builder.removeScope(args);
    }
    addFilterScope(args) {
        return this.builder.addFilterScope(args);
    }
    removeFilterScope(args) {
        return this.builder.removeFilterScope(args);
    }
    addField(args) {
        return this.builder.addFormField(args);
    }
    addColumn(args) {
        return this.builder.addColumn(args);
    }
    removeColumn(args) {
        return this.builder.removeColumn(args);
    }
    addForm(args) {
        return this.builder.addForm(args);
    }
    addCreateForm(args) {
        return this.builder.addCreateForm(args);
    }
    removeCreateForm(args) {
        return this.builder.removeCreateForm(args);
    }
    removeForm({ formName, scopeName, viewName }) {
        if (scopeName && viewName)
            return this.builder.removeFormFromScope({ formName, viewName, scopeName });
        return this.builder.removeForm(formName);
    }
    sortFormFields(args) {
        return this.builder.sortElements(args);
    }
    sortReadoutFields(args) {
        return this.builder.sortElements(args);
    }
    sortPreviewFields(args) {
        return this.builder.sortElements(args);
    }
    sortColumns(args) {
        return this.builder.sortElements(args);
    }
    removeField(args) {
        return this.builder.removeElement(args);
    }
    addPreview(args) {
        return this.builder.addPreview(args);
    }
    removePreview({ previewName, formName, fieldName }) {
        if (formName && fieldName)
            return this.builder.removePreviewFromForm({ previewName, formName, fieldName });
        return this.builder.removePreview(previewName);
    }
    addPreviewField(args) {
        return this.builder.addPreviewField(args);
    }
    removePreviewField(args) {
        return this.builder.removePreviewField(args);
    }
    addReadout(args) {
        return this.builder.addReadout(args);
    }
    removeReadout({ readoutName, scopeName, viewName }) {
        if (scopeName && viewName)
            return this.builder.removeReadoutFromScope({ readoutName, viewName, scopeName });
        return this.builder.removeReadout(readoutName);
    }
    addReadoutField(args) {
        return this.builder.addReadoutField(args);
    }
    removeReadoutField(args) {
        return this.builder.removeReadoutField(args);
    }
    addEvent(args) {
        return this.builder.addEvent(args);
    }
    removeEvent(args) {
        return this.builder.removeEvent(args);
    }
    addNavigationItem(args) {
        return this.builder.addNavigationItem(args);
    }
    removeNavigationItem(args) {
        return this.builder.removeNavigationItem(args);
    }
    sortNavigationItems(args) {
        return this.builder.sortNavigationItems(args);
    }
    addPlugin(args) {
        return this.builder.addPlugin(args);
    }
    removePlugin({ name, viewName, scopeName }) {
        return this.builder.removePlugin({ name, viewName, scopeName });
    }
    updateStructure(cb) {
        this.builder = cb(this);
    }
    applyStatements(statements) {
        const errors = [];
        for (const stmt of statements) {
            const prevBuilder = this.builder;
            let localErrors = [];
            try {
                this.handleStatement(stmt);
            }
            catch (e) {
                if (!this.silentErrors) {
                    console.warn(e);
                }
                const { message } = e;
                localErrors = [message];
            }
            if (localErrors.length === 0) {
                try {
                    localErrors = StructureValidator.validate(this.builder.application).map(it => it.message);
                }
                catch (e) {
                    localErrors = [e.message];
                }
            }
            if (localErrors.length) {
                this.builder = prevBuilder;
            }
            errors.push(...localErrors.map(it => ({
                ...stmt,
                error: it,
            })));
        }
        return { application: this.builder.application, errors: errors };
    }
    handleStatement(stmt) {
        if (stmt.type in this.statementHandlers) {
            this.statementHandlers[stmt.type].apply(stmt, this);
        }
        else {
            throw new AppStructureDslBuilderError(`Unknown statement type ${stmt.type}`);
        }
    }
}
//# sourceMappingURL=StructureDslBuilder.js.map